"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.getAccountBridge = exports.getCurrencyBridge = void 0;
var errors_1 = require("@ledgerhq/errors");
var account_1 = require("../account");
var env_1 = require("../env");
var support_1 = require("../account/support");
var js_1 = __importDefault(require("../generated/bridge/js"));
var mock_1 = __importDefault(require("../generated/bridge/mock"));
var getCurrencyBridge = function (currency) {
    if ((0, env_1.getEnv)("MOCK")) {
        var mockBridge = mock_1["default"][currency.family];
        if (mockBridge)
            return mockBridge.currencyBridge;
        throw new errors_1.CurrencyNotSupported("no mock implementation available for currency " + currency.id, {
            currencyName: currency.name
        });
    }
    var jsBridge = js_1["default"][currency.family];
    if (jsBridge) {
        return jsBridge.currencyBridge;
    }
    throw new errors_1.CurrencyNotSupported("no implementation available for currency " + currency.id, {
        currencyName: currency.name
    });
};
exports.getCurrencyBridge = getCurrencyBridge;
var getAccountBridge = function (account, parentAccount) {
    var mainAccount = (0, account_1.getMainAccount)(account, parentAccount);
    var currency = mainAccount.currency;
    var family = currency.family;
    var type = (0, account_1.decodeAccountId)(mainAccount.id).type;
    var supportedError = (0, support_1.checkAccountSupported)(mainAccount);
    if (supportedError) {
        throw supportedError;
    }
    if (type === "mock") {
        var mockBridge = mock_1["default"][currency.family];
        if (mockBridge)
            return mockBridge.accountBridge;
        throw new errors_1.CurrencyNotSupported("no mock implementation available for currency " + currency.id, {
            currencyName: currency.name
        });
    }
    var jsBridge = js_1["default"][family];
    if (type === "libcore") {
        // migrate from libcore via JS
        if (jsBridge) {
            return jsBridge.accountBridge;
        }
        throw new errors_1.CurrencyNotSupported("no libcore implementation available for currency " + currency.id, {
            currencyName: currency.name
        });
    }
    if (jsBridge)
        return jsBridge.accountBridge;
    throw new errors_1.CurrencyNotSupported("currency not supported " + currency.id, {
        currencyName: mainAccount.currency.name
    });
};
exports.getAccountBridge = getAccountBridge;
//# sourceMappingURL=impl.js.map